<div class="error-section">
  <span class="error" *ngIf="control.invalid && (control.touched || control.dirty)">
    <!-- TODO use commented version after adding ngx translate -->
    <!-- errorMsgKey | translate : errorMsgParams -->
    {{ errorMsg }}
  </span>
</div>
